import axios from "axios";

const apiUrl = process.env.REACT_APP_SOCKET_URL;
const apiUrl2 = process.env.REACT_APP_SOCKET_URL_2;

// =========================================
// Main axios instance
// =========================================
const axiosInstance = axios.create({
  baseURL: apiUrl + "api/",
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

const axiosInstance2 = axios.create({
  baseURL: apiUrl2 + "api/",
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

// =========================================
// ✅ Separate instance SIRF refresh ke liye
// Ye response interceptor se nahi guzrega
// Isliye infinite loop ya transform issue nahi hoga
// =========================================
const refreshInstance = axios.create({
  baseURL: apiUrl + "api/",
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

// =========================================
// REQUEST INTERCEPTOR
// =========================================
axiosInstance.interceptors.request.use(
  (config) => {

    const storeId = process.env.REACT_APP_STOREID;
    if(storeId) {
      config.headers["x-store-id"] = storeId;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// =========================================
// RESPONSE INTERCEPTOR
// =========================================
let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

axiosInstance.interceptors.response.use(
  // ✅ Success response transform
  (response) => {
    const { code, message, data } = response.data || {};
    return {
      code: code || 500,
      message: message || "Something went wrong! Try Again",
      data: data || null,
    };
  },

  // ✅ Error handler
  async (error) => {
    return Promise.reject(error);
  },
);

export default axiosInstance;

export {axiosInstance2}